/*
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-29 09:04:01
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-08 17:02:17
 * @Description: 移动端官网 route list，路由顺序慎改，会影响到 menu 的定位
 */

const phoneRoutes = [
  {
    path: '/m-index',
    name: 'm-index',
    // route level code-splitting
    // this generates a separate chunk (index.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: { title: '移动端首页' },
    component: () => import(/* webpackChunkName: "index" */ '@/pages/phone/index')
  },
  {
    path: '/m-perfect-select',
    name: 'm-perfect-select',
    redirect: '/m-perfect-select/m-project-list',
    meta: { title: '鲸鱼优选' },
    component: () =>
      import(/* webpackChunkName: "perfect-select" */ '@/pages/phone/perfect-select/index'),
    children: [
      {
        path: 'm-project-list',
        name: 'm-project-list',
        meta: { title: '优选列表' },
        component: () =>
          import(
            /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-list/index'
          )
      },
      {
        path: 'm-jing-yu-list',
        name: 'm-jing-yu-list',
        meta: { title: '鲸鱼优选列表' },
        component: () =>
          import(
            /* webpackChunkName: "number-one" */ '@/pages/phone/perfect-select/project-list/jing-yu-more'
          )
      },
      {
        path: 'm-number-one-list',
        name: 'm-number-one-list',
        meta: { title: '鲸鱼一号列表' },
        component: () =>
          import(
            /* webpackChunkName: "number-one" */ '@/pages/phone/perfect-select/project-list/number-one-more'
          )
      },
      {
        path: 'm-project-detail',
        name: 'm-project-detail',
        // redirect: '/m-project-detail/m-detail-content/:id/:flag',
        meta: { title: '标的详情' },
        component: () =>
          import(
            /* webpackChunkName: "perfect-select" */ '@/pages/phone/perfect-select/project-detail/index'
          ),
        children: [
          {
            path: 'm-detail-content/:id/:flag',
            name: 'm-detail-content',
            meta: { title: ' ' },
            component: () =>
              import(
                /* webpackChunkName: "project-detail" */ '@/pages/phone/perfect-select/project-detail/detail-content'
              )
          },
          {
            path: 'm-lend-recoder/:id/:flag',
            name: 'm-lend-recoder',
            meta: { title: '出借记录' },
            component: () =>
              import(
                /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-detail/lend-record/lend-record'
              )
          },
          {
            path: 'm-check-record',
            name: 'm-check-record',
            meta: { title: '审核记录' },
            component: () =>
              import(
                /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-detail/check-record/check-record'
              )
          },
          {
            path: 'm-project-produce',
            name: 'm-project-produce',
            meta: { title: '项目介绍' },
            component: () =>
              import(
                /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-detail/project-produce/base-data'
              )
          },
          {
            path: 'm-loan-contract',
            name: 'm-loan-contract',
            meta: { title: '借款合同' },
            component: () =>
              import(
                /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-detail/loan-contract/loan-contract'
              )
          },
          {
            path: 'm-repayment-plan/:id/:flag',
            name: 'm-repayment-plan',
            meta: { title: '还款计划' },
            component: () =>
              import(
                /* webpackChunkName: "project-list" */ '@/pages/phone/perfect-select/project-detail/repayment-plan/repayment-plan'
              )
          }
        ]
      },
      {
        path: 'm-risk-tips',
        name: 'm-risk-tips',
        meta: { title: '风险提示' },
        component: () =>
          import(/* webpackChunkName: "risk-tips" */ '@/pages/phone/perfect-select/risk-tips')
      },
      {
        path: 'm-agreement',
        name: 'm-agreement',
        meta: { title: '借款协议' },
        component: () =>
          import(/* webpackChunkName: "agreement" */ '@/pages/phone/perfect-select/agreement')
      }
    ]
  },
  // {
  //   path: '/m-borrowing',
  //   name: 'm-borrowing',
  //   meta: { title: '我要借款' },
  //   component: () => import(/* webpackChunkName: "borrowing" */ '@/pages/phone/borrowing')
  // },
  {
    path: '/m-information',
    name: 'm-information',
    redirect: '/m-information/m-bank-info',
    component: () =>
      import(/* webpackChunkName: "information" */ '@/pages/phone/information/index'),
    children: [
      {
        path: 'm-bank-info',
        name: 'm-bank-info',
        meta: { title: '银行存管' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/bank-info')
      },
      {
        path: 'm-check-info',
        name: 'm-check-info',
        meta: { title: '审核信息' },
        redirect: 'm-check-info/m-list',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/check-info/index'),
        children: [
          {
            path: 'm-list',
            name: 'm-check-info-list',
            meta: { title: '审核信息列表' },
            component: () =>
              import(/* webpackChunkName: "about" */ '@/pages/phone/information/check-info/list')
          },
          {
            path: 'm-fn-2016',
            name: 'm-fn-2016',
            meta: { title: '2016年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/check-info/financial-reports-2016'
              )
          },
          {
            path: 'm-fn-2017',
            name: 'm-fn-2017',
            meta: { title: '2017年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/check-info/financial-reports-2017'
              )
          },
          {
            path: 'm-fn-2018',
            name: 'm-fn-2018',
            meta: { title: '2018年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/check-info/financial-reports-2018'
              )
          },
          {
            path: 'm-sp-2018',
            name: 'm-sp-2018',
            meta: { title: '2018年专项审计报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/check-info/special-reports-2018'
              )
          },
          {
            path: 'm-im-2019',
            name: 'm-im-2019',
            meta: { title: '2019年重点环节专项审计报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/check-info/important-reports-2019'
              )
          }
        ]
      },
      {
        path: 'm-edu-for-lender',
        name: 'm-edu-for-lender',
        meta: { title: '出借人教育' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/edu-for-lender')
      },
      {
        path: 'm-importance-event',
        name: 'm-importance-event',
        meta: { title: '重大事项公布' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/importance-event')
      },
      {
        path: 'm-law',
        name: 'm-law',
        meta: { title: '法律法规' },
        component: () => import(/* webpackChunkName: "about" */ '@/pages/phone/information/law')
      },
      {
        path: 'm-operation-data',
        name: 'm-operation-data',
        meta: { title: '运营数据' },
        redirect: 'm-operation-data/m-current',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/operation-data'),
        children: [
          {
            path: 'm-current',
            name: 'm-current',
            meta: { title: '运营数据' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/operation-data/current'
              )
          },
          {
            path: 'm-total',
            name: 'm-total',
            meta: { title: '运营数据' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/phone/information/operation-data/total'
              )
          }
        ]
      },
      {
        path: 'm-organizetion',
        name: 'm-organizetion',
        meta: { title: '组织信息' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/organizetion')
      },
      {
        path: 'm-promise-file',
        name: 'm-promise-file',
        meta: { title: '合规经营承诺书' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/promise-file')
      },
      {
        path: 'm-records-info',
        name: 'm-records-info',
        meta: { title: '备案信息' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/records-info')
      },
      {
        path: 'm-risk-management',
        name: 'm-risk-management',
        meta: { title: '风险管理' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/risk-management')
      },
      {
        path: 'm-standard-for-charge',
        name: 'm-standard-for-charge',
        meta: { title: '收费标准' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/phone/information/standard-for-charge')
      }
    ]
  },
  {
    path: '/m-about-us',
    name: 'm-about-us',
    redirect: '/m-about-us/m-company-info',
    component: () => import(/* webpackChunkName: "about-us" */ '@/pages/phone/about-us/index'),
    children: [
      {
        path: 'm-company-info',
        name: 'm-company-info',
        meta: { title: '公司简介' },
        component: () =>
          import(/* webpackChunkName: "company-info" */ '@/pages/phone/about-us/company-info')
      },
      {
        path: 'm-party',
        name: 'm-party',
        meta: { title: '党建工作' },
        redirect: 'm-party/m-list',
        component: () => import(/* webpackChunkName: "party" */ '@/pages/phone/about-us/party'),
        children: [
          {
            path: 'm-list',
            name: 'm-party-list',
            meta: { title: '党建工作' },
            component: () =>
              import(/* webpackChunkName: "party-list" */ '@/pages/phone/about-us/party/list')
          },
          {
            path: 'm-content/:id',
            name: 'm-party-content',
            meta: { title: '党建工作' },
            component: () =>
              import(/* webpackChunkName: "party-content" */ '@/pages/phone/about-us/party/content')
          }
        ]
      },
      {
        path: 'm-news',
        name: 'm-news',
        meta: { title: '鲸鱼动态' },
        redirect: 'm-news/m-list',
        component: () => import(/* webpackChunkName: "news" */ '@/pages/phone/about-us/news'),
        children: [
          {
            path: 'm-list',
            name: 'm-news-list',
            meta: { title: '鲸鱼动态' },
            component: () =>
              import(/* webpackChunkName: "news-list" */ '@/pages/phone/about-us/news/list')
          },
          {
            path: 'm-content/:id',
            name: 'm-news-content',
            meta: { title: '鲸鱼动态' },
            component: () =>
              import(/* webpackChunkName: "news-content" */ '@/pages/phone/about-us/news/content')
          }
        ]
      },
      {
        path: 'm-announcement',
        name: 'm-announcement',
        meta: { title: '鲸鱼公告' },
        redirect: 'm-announcement/m-list',
        component: () =>
          import(/* webpackChunkName: "announcement" */ '@/pages/phone/about-us/announcement'),
        children: [
          {
            path: 'm-list',
            name: 'm-announcement-list',
            meta: { title: '鲸鱼公告' },
            component: () =>
              import(
                /* webpackChunkName: "announcement-list" */ '@/pages/phone/about-us/announcement/list'
              )
          },
          {
            path: 'm-content/:id',
            name: 'm-announcement-content',
            meta: { title: '鲸鱼公告' },
            component: () =>
              import(
                /* webpackChunkName: "announcement-content" */ '@/pages/phone/about-us/announcement/content'
              )
          }
        ]
      },
      {
        path: 'm-cooperative-partner',
        name: 'm-cooperative-partner',
        meta: { title: '合作伙伴' },
        component: () =>
          import(
            /* webpackChunkName: "cooperative-partner" */ '@/pages/phone/about-us/cooperative-partner'
          )
      },
      {
        path: 'm-contact-us',
        name: 'm-contact-us',
        meta: { title: '联系我们' },
        component: () =>
          import(/* webpackChunkName: "contact-us" */ '@/pages/phone/about-us/contact-us')
      },
      {
        path: 'm-join-us',
        name: 'm-join-us',
        meta: { title: '加入我们' },
        component: () => import(/* webpackChunkName: "join-us" */ '@/pages/phone/about-us/join-us')
      }
    ]
  }
];

export default phoneRoutes;
